
import { css } from 'lit';
export default css`
::slotted([slot='header-main']) {
  margin-top: 1rem;
}@media (min-width: 360px) {::slotted([slot='header-main']) {
    margin-top: 3rem;
  }
}
::slotted([slot='share']) {
  margin-top: 1.25rem;
  text-align: right;
}
@media (min-width: 1024px) {::slotted([slot='share']) {
    position: absolute;
  }::slotted([slot='share']) {
    bottom: 1rem;
  }::slotted([slot='share']) {
    right: 2rem;
  }
}
@media (min-width: 1200px) {::slotted([slot='share']) {
    right: 0px;
  }
}
::slotted([slot='header-published']) {
  margin-top: 1.25rem;
  text-align: left;
}
@media (min-width: 1024px) {::slotted([slot='header-published']) {
    position: absolute;
  }::slotted([slot='header-published']) {
    bottom: 1rem;
  }::slotted([slot='header-published']) {
    left: 0px;
  }
}
.page-header__wrapper {
  position: relative;
}
.page-header__wrapper {
  border-left-width: 1px;
}
.page-header__wrapper {
  border-right-width: 1px;
}
.page-header__wrapper {
  border-style: solid;
}
.page-header__wrapper {
  --tw-border-opacity: 1;
  border-color: rgba(107, 31, 153, var(--tw-border-opacity));
}
.page-header__wrapper {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}
.page-header__wrapper {
  padding-top: 1rem;
}
.page-header__wrapper {
  padding-bottom: 1.5rem;
}
.page-header__wrapper {
  padding-right: 1rem;
}
.page-header__wrapper {
  --tw-text-opacity: 1;
  color: rgba(255, 255, 255, var(--tw-text-opacity));
}
@media (min-width: 640px) {.page-header__wrapper {
    padding-right: 0px;
  }
}
@media (min-width: 1024px) {.page-header__wrapper {
    padding-bottom: 5rem;
  }
}
.page-header__wrapper--recipe {
  padding-bottom: 1rem;
}
@media (min-width: 1024px) {.page-header__wrapper--recipe {
    padding-bottom: 0px;
  }
}
.page-header__wrapper::before {
  position: absolute;
}
.page-header__wrapper::before {
  top: 0px;
}
.page-header__wrapper::before {
  z-index: -10;
}
.page-header__wrapper::before {
  height: 100%;
}
.page-header__wrapper::before {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}
.page-header__wrapper::before {
      content: '';
      width: 100vw;
      transform: translateX(-100%);
    }
@media screen and (min-width: 1440px) {
.page-header__wrapper::before {
        width: 19%
    }
      }
.page-header__wrapper::after {
  position: absolute;
}
.page-header__wrapper::after {
  left: 100%;
}
.page-header__wrapper::after {
  top: 0px;
}
.page-header__wrapper::after {
  z-index: -10;
}
.page-header__wrapper::after {
  height: 100%;
}
.page-header__wrapper::after {
  --tw-bg-opacity: 1;
  background-color: rgba(107, 31, 153, var(--tw-bg-opacity));
}
.page-header__wrapper::after {
      content: '';
      width: calc((100vw - 100%) / 2);
    }
@media screen and (min-width: 1440px) {
.page-header__wrapper::after {
        width: 19%
    }
      }
@media (min-width: 1024px) {
.page-header__wrapper {
      margin-top: 24px
  }
    }
.page-header__icon {
  position: absolute;
}
.page-header__icon {
  bottom: 0px;
}
.page-header__icon {
  display: none;
}
.page-header__icon {
  height: 7rem;
}
.page-header__icon {
  width: 8rem;
}
.page-header__icon {
  fill: currentColor;
}
@media (min-width: 1024px) {.page-header__icon {
    display: block;
  }
}
.page-header__icon {
    
    right: calc(50% - 50vw);
  }
@media (min-width: 768px) {
.page-header__icon {
      right: -7em
  }
    }
@media (min-width: 1024px) {
.page-header__icon {
      right: -10em
  }
    }
@media print {
  .page-header__wrapper {
    color: #000 !important;
    background: transparent;
    overflow: hidden;
  }

    .page-header__wrapper::after,
    .page-header__wrapper::before {
      display: none;
    }
    .page-header__icon {
      display: block !important;
      right: 0;
    }
}
`;